import { registerMutation } from 'data-fetching-client';
import { hubUserAttributesClient } from '../clients/hubUserAttributesClient';
export const setSingleHubUserSettingMutation = registerMutation({
  fieldName: 'singleHubUserSettingMutation',
  args: ['settingsKey', 'value'],
  fetcher: args => hubUserAttributesClient.write(args.settingsKey, args.value)
});